import { EMAIL_CONFIRMATION_STARTED, EMAIL_CONFIRMATION_DONE, EMAIL_CONFIRMATION_FAILED } from '../actions/actionTypes'

const initialState = {
  fetching: false,
  error: ''
}

export const sendConfirmationEmail = (state = initialState, action) => {
  switch (action.type) {
    case EMAIL_CONFIRMATION_STARTED: {
      return {
        ...state,
        fetching: true
      }
    }
    case EMAIL_CONFIRMATION_DONE: {
      return {
        ...state,
        fetching: false
      }
    }
    case EMAIL_CONFIRMATION_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    default:
      return state
  }
}
